
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface ActiveSubscriptionProps {
  onCancel: () => void;
}

export const ActiveSubscription = ({ onCancel }: ActiveSubscriptionProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <h3 className="font-medium">Manage Your Subscription</h3>
          <Button
            variant="outline"
            className="w-full sm:w-auto"
            onClick={onCancel}
          >
            Cancel Subscription
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
